import { shuffleArray } from '../base'

const subjectsArr = [
  'Let\'s make something extraordinary',
  'Let\'s build the impossible',
  'Let\'s create magic together'
]

export const getRandomEmailSubject:() => string = () => shuffleArray(subjectsArr)[0]

export const getMailToWithSubject = () => {
  const subject = getRandomEmailSubject()
  return `mailto:hola@you.digital?subject=${encodeURIComponent(subject)}`
}
